export const STATUS_CONFIG = {
    draft: { label: "Draft", color: "#475569", bg: "#dcedffff" },
    sent: { label: "Sent", color: "#075985", bg: "#d6efffff" },
    partially_received: { label: "Partial Rates", color: "#b45309", bg: "#f8efcaff" },
    received: { label: "All Rates In", color: "#6d28d9", bg: "#e3defbff" },
    under_review: { label: "Under Review", color: "#c2410c", bg: "#f9e5ceff" },
    finalized: { label: "Finalized", color: "#166534", bg: "#d1fce0ff" },
    ordered: { label: "Ordered", color: "#ff6923", bg: "#fff7f1" },
    cancelled: { label: "Cancelled", color: "#b91c1c", bg: "#ffd1d1ff" },
};

export const STORE_QUOTATION_STATUS = {
    DRAFT: "draft",
    SENT: "sent",
    PARTIALLY_RECEIVED: "partially_received",
    RECEIVED: "received",
    UNDER_REVIEW: "under_review",
    FINALIZED: "finalized",
    ORDERED: "ordered",
    CANCELLED: "cancelled",
}

export const PARTY_STATUS_CONFIG = {
    invited: { label: "Awaiting", color: "#94a3b8" },
    rate_received: { label: "Rates In", color: "#f59e0b" },
    accepted: { label: "Accepted", color: "#34d399" },
    rejected: { label: "Rejected", color: "#f87171" },
};

export const fmt = (n) => (n || n === 0) ? `${Number(n).toFixed(2)}` : "-";
export const genId = () => Math.random().toString(36).slice(2, 10);
